<app-metadata
  [graphName]="'water-use-and-quality-effluent-good'"
  [displayString]="'Effluent Water Quality Metadata'"
></app-metadata>
<app-metadata
  [graphName]="'water-use-and-quality-surface-good'"
  [displayString]="'Surface Water Quality Metadata'"
></app-metadata>
<app-metadata
  [graphName]="'water-use-and-quality-groundwater-good'"
  [displayString]="'Groundwater Quality Metadata'"
></app-metadata>
<mat-card>
  @if (data) {
    <mat-card-content>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!(activateSaveButton && hasValidData())"
        (click)="updateData()"
        i18n="save@@save"
        >
      Save
    </button>
      <button
        mat-raised-button
        style="margin-left: 5em"
        color="warn"
        (click)="resetForms()"
        i18n="cancel@@cancel"
        >
      Cancel
    </button>
      @if (data && informations) {
        <div>
          <app-form
            [informations]="informations"
            [data]="data"
            [showButton]="false"
            [helptexts]="helptexts"
            (formChanges)="onFormUpdates('formData', $event)"
          ></app-form>
        </div>
      }
      @for (info of sampleInformations; track info) {
        <div>
          <div class="row">
            <div class="col">
              <app-forms-sample
                [title]="info['display_' + locale]"
                [sampleCarrier]="data"
                [sampleName]="info.fieldName"
                [helptexts]="helptexts"
                [qualityType]="'water_quality'"
                [qualityEndpoint]="'water-qualities'"
                (formUpdates)="onFormUpdates(info.fieldName, $event)"
              ></app-forms-sample>
            </div>
          </div>
        </div>
      }
    </mat-card-content>
  }
</mat-card>
